import React from "react";
import { Link } from "react-router-dom";

const BackArrow = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <line x1="19" y1="12" x2="5" y2="12" />
    <polyline points="12 19 5 12 12 5" />
  </svg>
);

const TermsConditions: React.FC = () => {
  return (
    <main className="mx-auto px-4 py-8">
      <Link
        to="/dashboard"
        className="inline-flex items-center gap-2 text-[#003366] font-medium mb-6 hover:bg-[#003366] rounded-md px-3 py-2 hover:text-white transition-colors duration-200"
      >
        <BackArrow />
        Back to Dashboard
      </Link>

      <h1 className="text-3xl font-bold text-[#003366] text-center mb-8">
        Terms &amp; Conditions
      </h1>

      <p className="text-gray-700 text-base leading-relaxed mb-4">
        This website is designed, developed and maintained by the Ministry of
        Social Justice and Empowerment, Government of India.
      </p>
      <p className="text-gray-700 text-base leading-relaxed mb-4">
        Though all efforts have been made to ensure the accuracy and currency of
        the content on this website, the same should not be construed as a
        statement of law or used for any legal purposes. In case of any
        ambiguity or doubts, users are advised to verify/check with the
        Department and/or other sources and to obtain appropriate professional
        advice.
      </p>
      <p className="text-gray-700 text-base leading-relaxed mb-4">
        Under no circumstances will this Department be liable for any expense,
        loss or damage including, without limitation, indirect or consequential
        loss or damage, or any expense, loss or damage whatsoever arising from
        use, or loss of use, of data, arising out of or in connection with the
        use of this website.
      </p>
      <p className="text-gray-700 text-base leading-relaxed mb-4">
        These terms and conditions shall be governed by and construed in
        accordance with the Indian Laws. Any dispute arising under these terms
        and conditions shall be subject to the jurisdiction of the courts of
        India.
      </p>
      <p className="text-gray-700 text-base leading-relaxed mb-4">
        The information posted on this website could include hypertext links or
        pointers to information created and maintained by non-government/private
        organisations. Ministry of Social Justice and Empowerment is providing
        these links and pointers solely for your information and convenience.
        When you select a link to an outside website, you are leaving the
        Ministry of Social Justice and Empowerment website and are subject to
        the privacy and security policies of the owners/sponsors of the outside
        website.
      </p>
      <p className="text-gray-700 text-base leading-relaxed">
        Ministry of Social Justice and Empowerment, does not guarantee the
        availability of such linked pages at all times.
      </p>
    </main>
  );
};

export default TermsConditions;
